import src from "IMAGE";
export default { src, width: 157, height: 31, blurWidth: 0, blurHeight: 0};
